import { render, staticRenderFns } from "./SolicitacoesAcessoAnoDash.vue?vue&type=template&id=1eeed687&"
import script from "./SolicitacoesAcessoAnoDash.vue?vue&type=script&lang=js&"
export * from "./SolicitacoesAcessoAnoDash.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports